import { required } from "@vuelidate/validators";
import { maxLength } from "vuelidate/lib/validators";
import Responsible from "./responsible";
export default class Event {
  constructor() {
    this.id = null;
    this.responsible = new Responsible({});
    this.local = null;
    this.name = null;
    this.pae = null;
    this.type = null;
    this.dtCreated = null;
    this.dtUpdate = null;
    this.dtCancel = null;
    this.status = "REQUESTED";
    this.description = null;
    this.observation = null;
    this.participants = null;
    this.nparticipants = null;
    this.calendars = [];
    this.equipaments = [];
    //this.historys = [];
  }

  validations() {
    return {
      local: {
        required,
      },
      name: {
        required,
        maxLength: maxLength(100),
      },
      pae: {
      },
      type: {
        required,
      },
      status: {},
      description: {
        required,
      },
      participants: {
      },
      calendars: {
      },
      equipaments: {
        required,
      },
      observation: {},
    };
  }
}
